import axios from "axios";

    // module-specific base URL configured via env var
    const baseUrl = process.env.VUE_APP_API_URL_LAUNCH_PERMIT || '';

    const httpClient = axios.create({
      headers: {
        "Content-Type": "application/json"
      },
      timeout: 120000
    });

    httpClient.interceptors.response.use(
      response => response,
      error => errorInterceptor(error)
    );

    const errorInterceptor = error => {
      if (error && !error.response) {
        if (error.code === "ECONNABORTED") {
          error.response = {
            data: {
              isSucess: false,
              errors: {
                Files: [
                  "Request has timed out. Please try again, if issue persists then call our support team"
                ]
              }
            }
          };
        }
      }
      return Promise.reject(error);
    };

   export default {
      healthCheck() {
        return httpClient.get(baseUrl);
      },
      fetchConfiguration(){
        return httpClient.get(`${baseUrl}/configuration`);
      },
      submit(payload) {
        return httpClient.post(`${baseUrl}/create`, payload);
      }
   };